import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContractHeader = ({ contract, onEdit, onExport, onArchive }) => {
  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case 'active': return 'bg-success/10 text-success border-success/20';
      case 'pending': return 'bg-warning/10 text-warning border-warning/20';
      case 'expired': return 'bg-error/10 text-error border-error/20';
      case 'draft': return 'bg-muted text-muted-foreground border-border';
      default: return 'bg-muted text-muted-foreground border-border';
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    })?.format(amount);
  };

  const formatDate = (dateString) => {
    return new Date(dateString)?.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <div className="bg-card border-b border-border">
      <div className="px-6 py-6">
        {/* Breadcrumb */}
        <nav className="flex items-center space-x-2 text-sm text-muted-foreground mb-4">
          <span>Dashboard</span>
          <Icon name="ChevronRight" size={14} />
          <span>Contracts</span>
          <Icon name="ChevronRight" size={14} />
          <span className="text-foreground font-medium">{contract?.title}</span>
        </nav>

        {/* Header Content */}
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <div className="flex items-center space-x-3 mb-3">
              <h1 className="text-2xl font-bold text-foreground">{contract?.title}</h1>
              <div className={`px-3 py-1 rounded-full text-sm font-medium border ${getStatusColor(contract?.status)}`}>
                {contract?.status}
              </div>
            </div>

            {/* Contract Metadata */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 text-sm">
              <div>
                <p className="text-muted-foreground mb-1">Contract ID</p>
                <p className="font-mono text-foreground">{contract?.id}</p>
              </div>
              <div>
                <p className="text-muted-foreground mb-1">Contract Value</p>
                <p className="font-semibold text-foreground">{formatCurrency(contract?.value)}</p>
              </div>
              <div>
                <p className="text-muted-foreground mb-1">Start Date</p>
                <p className="text-foreground">{formatDate(contract?.startDate)}</p>
              </div>
              <div>
                <p className="text-muted-foreground mb-1">End Date</p>
                <p className="text-foreground">{formatDate(contract?.endDate)}</p>
              </div>
            </div>

            {/* Parties */}
            <div className="mt-4 flex items-center space-x-6 text-sm">
              <div>
                <p className="text-muted-foreground mb-1">Client</p>
                <p className="text-foreground font-medium">{contract?.client}</p>
              </div>
              <div>
                <p className="text-muted-foreground mb-1">Vendor</p>
                <p className="text-foreground font-medium">{contract?.vendor}</p>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex items-center space-x-3 ml-6">
            <Button
              variant="outline"
              size="sm"
              iconName="Download"
              iconPosition="left"
              onClick={onExport}
            >
              Export
            </Button>
            <Button
              variant="outline"
              size="sm"
              iconName="Archive"
              iconPosition="left"
              onClick={onArchive}
            >
              Archive
            </Button>
            <Button
              variant="default"
              size="sm"
              iconName="Edit3"
              iconPosition="left"
              onClick={onEdit}
            >
              Edit Contract
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContractHeader;